import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";

function getScoreColor(score) {
  if (score >= 80) return "text-[#14B8A6]";
  if (score >= 60) return "text-[#F59E0B]";
  return "text-red-500";
}

function getScoreBarColor(value) {
  if (value >= 80) return 'bg-[#14B8A6]';
  if (value >= 60) return 'bg-[#F59E0B]';
  return 'bg-red-500';
}

export function CompetenciesTab({ evaluation }) {
  return (
    <Card className="premium-card">
      <CardHeader>
        <CardTitle className="text-base font-bold text-[#0B1F3B]">Competency Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {evaluation.competency_scores && Object.entries(evaluation.competency_scores).map(([key, value]) => (
            <div key={key} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-slate-600 capitalize">{key.replace(/_/g, ' ')}</span>
                <span className={`text-sm font-bold ${getScoreColor(value)}`}>{value}%</span>
              </div>
              <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden">
                <div 
                  className={`h-full rounded-full transition-all duration-700 ${getScoreBarColor(value)}`}
                  style={{ width: `${value}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
